<button (click)="selectedTable = 'device'" [ngClass]="{'btn-hover-primary--active' : selectedTable === 'device'}"
        class="btn btn-hover-primary">{{'lang.globals.devices' | translate}}</button>
<button (click)="selectedTable = 'location'" [ngClass]="{'btn-hover-primary--active' : selectedTable === 'location'}"
        class="btn btn-hover-primary">{{'lang.globals.locations' | translate}}</button>
<ng-container [ngSwitch]="true">
  <sb-page-devices (elementSelected)="handleSelection($event, 'device')"
                   *ngSwitchCase="selectedTable === 'device'"
                   [selectionMode]="true"></sb-page-devices>
  <sb-page-locations (elementSelected)="handleSelection($event, 'location')"
                     *ngSwitchCase="selectedTable === 'location'" [selectionMode]="true"></sb-page-locations>
</ng-container>
